import { useRef } from "react";
import AgGrid from "../../../UI/AgGrid";
import useCurrencySettingColumnDefs from "./useCurrencySettingColumnDefs";

type Props = {
  onEditHandler: (id?: number) => void;
  onDeleteHandler: (id?: number) => void;
  data: any[];
};

const CurrencySettingTable = ({
  onEditHandler,
  onDeleteHandler,
  data,
}: Props) => {
  const gridRef = useRef(null);
  const columnDefs = useCurrencySettingColumnDefs(
    onEditHandler,
    onDeleteHandler
  );

  return (
    <AgGrid
      columnDefs={columnDefs}
      ref={gridRef}
      rowData={data || []}
      height={650}
      disabledSidebar
    />
  );
};

export default CurrencySettingTable;
